import React from 'react';
import PropTypes from 'prop-types';
import { PublicationType } from 'propTypes/entities';

import BaseSlider from 'components/sliders/BaseSlider';
import PublicationCard from 'components/cards/entities/PublicationCard';

import { SCREEN_BREAKPOINTS } from 'utils/helpers/constants';

const Publications = ({ entities }) => (
	<BaseSlider
		theme="full"
		params={{
			slidesPerView: 'auto',
			spaceBetween: 8,
			breakpoints: {
				[SCREEN_BREAKPOINTS.tabletLarge]: {
					slidesPerView: 4,
					spaceBetween: 24
				},
				[SCREEN_BREAKPOINTS.desktopMedium]: {
					slidesPerView: 5,
					spaceBetween: 24
				}
			}
		}}
	>
		{entities.map((publication) => (
			<PublicationCard
				key={publication._id}
				entity={publication}
				typeWidth="fluidLandscapeSlide"
			/>
		))}
	</BaseSlider>
);

Publications.propTypes = {
	entities: PropTypes.arrayOf(PublicationType).isRequired
};

export default Publications;
